import fbo from "../../images/facebook_logo_w.png"
import ins from "../../images/instagram_logo_w.png"
import twi from "../../images/twitter_logo_w.png"

function SocialMedia() {
  return (
    <div className="banner-social-media-container">
      <a className="social-media-a" href="https://www.facebook.com/romaprov/" target="_blank" rel="noreferrer" >
        <img className="social-media-img" src={fbo} alt="Facebook link" />
      </a>
      <a className="social-media-a" href="https://www.instagram.com/romapvd/?hl=en" target="_blank" rel="noreferrer" >
        <img className="social-media-img" src={ins} alt="Instagram link" />
      </a>
      <a className="social-media-a" href="https://twitter.com/romaprovidence" target="_blank" rel="noreferrer" >
        <img className="social-media-img" src={twi} alt="Twitter link" />
      </a>
    </div>
  )
}

export default SocialMedia
